import { render, staticRenderFns } from "./screenPlayer.vue?vue&type=template&id=ef2d865a&scoped=true&"
import script from "./screenPlayer.ts?vue&type=script&lang=js&"
export * from "./screenPlayer.ts?vue&type=script&lang=js&"
import style0 from "./screenPlayer.less?vue&type=style&index=0&id=ef2d865a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2d865a",
  null
  
)

export default component.exports